/** @jsxRuntime classic */
/** @jsx jsx */
import { useMonth } from "@datepicker-react/hooks";
import { jsx } from "@emotion/core";
import Day from "./Day";
import NavButton from "./NavButton";
import prev from '../assets/prv.svg';
import nxt from '../assets/nxt.svg';
import { TodayMenuIcon } from "../../LandingHeader/Feedback/icons/Icons";
import moment from "moment";

function Month({ year, month, firstDayOfWeek, goToPreviousMonths, goToNextMonths, gotoToday }) {
  const { days, weekdayLabels, monthLabel } = useMonth({
    year,
    month,
    firstDayOfWeek,
    weekdayLabelFormat: (date) => moment(date).format('dd')[0]
  });

  return (
    <div>
      <div className="flex justify-between items-center m-0 mb-[16px] p-0 pl-[20px] pr-[20px]">
        <strong className="text-[var(--theme-mode-color-white-reverse)] font-inter text-sm font-normal line-height-normal opacity-50 uppercase">{monthLabel}</strong>
        <div className="buttonAction">
          <NavButton onClick={goToPreviousMonths}><img src={prev} className="dark:invert-color" /></NavButton>
          <span style={{cursor: "pointer"}} className="crcl datepicker-month-nav" onClick={gotoToday}><TodayMenuIcon activeStyleHome={true} color={month == new Date().getMonth() && year == new Date().getFullYear() ? 'grey' : `var(--accent-color)`} fill={month == new Date().getMonth() && year == new Date().getFullYear() ? 'none' : `var(--accent-color)`} /></span>
          <NavButton onClick={goToNextMonths}><img src={nxt} className="dark:invert-color" /></NavButton>
        </div>
      </div>
      <div
        className="grid grid-cols-7 justify-center mb-[10px] text-[10px] opacity-50 p-0 pl-[20px] pr-[20px]"
        css={{
          background: 'rgba(var(--theme-mode-rgb-white-reverse), 0.10)'
        }}
      >
        {weekdayLabels.map((dayLabel, index) => (
          <div
          className="text-center text-[var(--theme-mode-color-white-reverse)] p-2 font-inter text-sm font-normal line-height-normal"
          css={{
            lineHeight: 'normal'
          }} key={index}>
            {dayLabel.toUpperCase()}
          </div>
        ))}
      </div>
      <div className="grid grid-cols-7 justify-center p-0 pl-[20px] pr-[20px]">
        {days.map((day, index) => {
          if (typeof day === "object") {
            return (
              <Day
                date={day.date}
                key={day.date.toString()}
                dayLabel={day.dayLabel}
              />
            );
          }

          return <div key={index} />;
        })}
      </div>
    </div>
  );
}

export default Month;
